import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { pathOr } from 'ramda';
import { Progress } from 'antd';
import { connect } from 'react-redux';
import ReactHowler from 'react-howler';
import { withRouter } from 'react-router-dom';
import PlayIcon from 'material-design-icons/av/svg/production/ic_play_arrow_24px.svg';
import ErrorIcon from 'material-design-icons/content/svg/production/ic_clear_24px.svg';
import PauseIcon from 'material-design-icons/av/svg/production/ic_pause_24px.svg';

import { trackStartPlaying, trackStopPlaying, trackPausePlaying } from '../../actions/player';
import analytics from '../../helpers/analytics';

import c from './PreviewTrack.less';

class PreviewTrackComponent extends Component {
  player = {};

  playTimer = null;

  static propTypes = {
    trackId: PropTypes.number.isRequired,
    trackStartPlaying: PropTypes.func.isRequired,
    trackStopPlaying: PropTypes.func.isRequired,
    trackPausePlaying: PropTypes.func.isRequired,
    onEnd: PropTypes.func,
    className: PropTypes.string,
    src: PropTypes.string,
    ariaLabel: PropTypes.string,
    trackIsPurchased: PropTypes.bool.isRequired,
    fileSize: PropTypes.number,
    player: PropTypes.object.isRequired,
  };

  static defaultProps = {
    onEnd: () => null,
    className: '',
    src: null,
    fileSize: 0,
    ariaLabel: null,
  };

  state = {
    errorLoading: false,
    isLoaded: false,
    isPlaying: false,
    progress: 0,
  };

  UNSAFE_componentWillReceiveProps(newProps) {
    if (newProps.player.playingTrack === this.props.trackId && newProps.player.isPaused !== !this.state.isPlaying) {
      if (newProps.player.isPaused) {
        this.pause();
      } else {
        this.play();
      }
    }

    if (this.state.isPlaying && newProps.player.playingTrack !== null && newProps.player.playingTrack !== this.props.trackId) {
      this.stop();
    }
  }

  componentWillUnmount() {
    if (this.state.isPlaying) {
      this.stop();

      this.props.trackStopPlaying();
    }
  }

  getSourceUrl = () => {
    if (this.props.trackIsPurchased) {
      return this.props.src;
    }

    return `${process.env.PREVIEW_URL}${this._splitId(this.props.trackId)}.mp3`;
  };

  pause = () => {
    this.setState({
      isPlaying: false,
    });

    clearInterval(this.playTimer);
  };

  play = () => {
    if (!this.state.isLoaded) {
      this.player.howler.on('playerror', () => {
        this.handlePlayError();
      });
    }

    this.playTimer = setInterval(() => this.handleProgress(), 500);

    this.setState({
      isPlaying: true,
      isLoaded: true,
    });

    analytics.trackEvent({
      category: pathOr(undefined, ['state', 'analytics', 'category'], this.props.location),
      action: this.props.trackIsPurchased ? 'Play' : 'Preview',
      label: 'Track',
      value: this.props.fileSize,
    });
  };

  stop = () => {
    this.setState({
      isPlaying: false,
    });

    clearInterval(this.playTimer);
  };

  _splitId = (id) => {
    return String(id)
      .padStart(7, '0')
      .split('')
      .reduce((acc, symb, idx) => {
        if (idx > 0 && idx % 3 === 0) {
          acc.push('/');
        }
        acc.push(symb);

        return acc;
      }, [])
      .join('');
  };

  handleMediaEnd = () => {
    this.stop();

    this.props.onEnd();
  };

  handlePlayError = () => {
    this.stop();
  };

  handleMediaError = (err) => {
    if (!err) return;

    this.setState({
      errorLoading: true,
      isPlaying: false,
    });

    this.props.trackStopPlaying();
  };

  handleProgress = () => {
    if (!this.player) return;

    const currentPos = this.player.seek();

    if (typeof currentPos === 'number') {
      this.setState({
        progress: (currentPos / this.player.duration()) * 100,
      });
    }
  };

  handleToggleTrack = () => {
    if (this.state.isPlaying) {
      this.props.trackPausePlaying();
    } else {
      this.props.trackStartPlaying(this.props.trackId);
    }
  };

  renderProgress() {
    const { isPlaying, progress } = this.state;
    const centerIcon = () => isPlaying ? // eslint-disable-line
      <PauseIcon className={c.pauseIcon} />
      : <PlayIcon className={c.icon} />;

    return (
      <Fragment>
        <Progress
          type="circle"
          percent={isPlaying ? progress : 100}
          width={30}
          trailColor="#f2f2f2"
          strokeWidth={10}
          format={centerIcon}
          className="hidden-desktop"
        />
        <Progress
          type="circle"
          percent={isPlaying ? progress : 100}
          width={26}
          trailColor="#f2f2f2"
          strokeWidth={10}
          format={centerIcon}
          className="visible-desktop"
        />
      </Fragment>
    );
  }

  render() {
    const { className } = this.props;
    const { errorLoading, isPlaying } = this.state;

    let icon = this.renderProgress();

    if (errorLoading) {
      icon = <ErrorIcon className={cx(c.icon, c.errorIcon)} />;
    }

    return (
      <>
        <button
          type="button"
          className={cx(c.container, className)}
          onClick={this.handleToggleTrack}
          aria-label={this.props.ariaLabel}
        >
          <span className={c.progress}>{icon}</span>
        </button>
        <ReactHowler
          src={this.getSourceUrl()}
          format={['mp3']}
          html5
          preload={false}
          playing={isPlaying}
          onEnd={this.handleMediaEnd}
          onLoadError={this.handleMediaError}
          ref={(el) => {
            this.player = el;
          }}
          onPlayError={this.handlePlayError}
        />
      </>
    );
  }
}

export default withRouter(connect(
  (state) => ({
    player: state.player,
  }),
  {
    trackStartPlaying,
    trackStopPlaying,
    trackPausePlaying,
  },
)(PreviewTrackComponent));
